import { configureStore } from '@reduxjs/toolkit';
import authReducer from 'redux/slices/authSlice';
import treeDataReducer from 'redux/slices/treedata';
import getUsersReducer from 'redux/slices/userSlice';
import createUserReducer from 'redux/slices/createUser';
import getChildOuReducer from 'redux/slices/getChildOu';
import ouTreeDataReducer from 'redux/slices/ouAdminTree';
import getOuGroupReducer from 'redux/slices/getOuGroups';
import domainDataReducer from 'redux/slices/domainSlice';
import getUserInGroupReducer from 'redux/slices/getUserInGroup';
import getUserNotInGroupReducer from 'redux/slices/getUserNotInGroup';
import mailTemplateReducer from 'redux/slices/mailTemplateSlice';
import resetPasswordReducer from 'redux/slices/resetPassword';
import getOuComputersReducer from 'redux/slices/getOuComputers';
import selectedNodeReducer from 'redux/slices/selectedNodeSlice';
import usersGroupSliceReducer from 'redux/slices/usersGroupSlice';
import setupReducer from 'redux/slices/setupSlice';
import settingsSlice from 'redux/slices/settingsSlice';
import licenseReducer from 'redux/slices/licenseSlice';
import mailDeliverySlice from 'redux/slices/mailDeliverySlice';
import themeSlice from 'redux/slices/themeSlice';
import endpoints from 'redux/slices/endpointsSlice';
import brandingSlice from 'redux/slices/brandingSlice';
import apiSettings from 'redux/slices/apiSettings';

const store = configureStore({
  reducer: {
    authenticatedUser: authReducer,
    treeData: treeDataReducer,
    ouTreeData: ouTreeDataReducer,
    getUsers: getUsersReducer,
    createUserData: createUserReducer,
    getChildOuData: getChildOuReducer,
    resetUserPassword: resetPasswordReducer,
    getOuGroupData: getOuGroupReducer,
    getOuComputersData: getOuComputersReducer,
    selectedNode: selectedNodeReducer,
    domainData: domainDataReducer,
    getUserInGroupData: getUserInGroupReducer,
    getUserNotInGroupData: getUserNotInGroupReducer,
    mailTemplate: mailTemplateReducer,
    settings: settingsSlice,
    usersGroupSlice: usersGroupSliceReducer,
    setupSlice: setupReducer,
    licenseSlice: licenseReducer,
    mailDelivery: mailDeliverySlice,
    themes: themeSlice,
    endpoints: endpoints,
    brandings: brandingSlice,
    apikeys: apiSettings,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
